/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Sync_ConfirmInputs */

const en_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This process will attempt to automatically sync the transcript with the current event group. Would you like to proceed?`)
};

const fr_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce processus tentera de synchroniser automatiquement la transcription avec le groupe d'événements actuel. Souhaitez-vous continuer ?`)
};

const de_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vorgang versucht, das Transkript automatisch mit der aktuellen Ereignisgruppe zu synchronisieren. Möchten Sie fortfahren?`)
};

const it_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo processo tenterà di sincronizzare automaticamente la trascrizione con il gruppo di eventi corrente. Vuoi procedere?`)
};

const ru_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ходе этого процесса будет предпринята попытка автоматически синхронизировать стенограмму с текущей группой событий. Вы хотите продолжить?`)
};

const es_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este proceso intentará sincronizar automáticamente la transcripción con el grupo de eventos actual. ¿Desea continuar?`)
};

const zh_cn2_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此过程将尝试自动将记录与当前事件组同步。您是否要继续？`)
};

const ja_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプロセスでは、トランスクリプトを現在のイベントグループと自動的に同期しようとします。続行しますか?`)
};

const hi_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह प्रक्रिया स्वचालित रूप से ट्रांसक्रिप्ट को वर्तमान इवेंट समूह के साथ सिंक्रनाइज़ करने का प्रयास करेगी। क्या आप आगे बढ़ना चाहेंगे?`)
};

const pt_pt2_automatic_sync_confirm = /** @type {(inputs: Automatic_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este processo tentará sincronizar automaticamente a transcrição com o grupo de eventos atual. Deseja prosseguir?`)
};

/**
* | output |
* | --- |
* | "This process will attempt to automatically sync the transcript with the current event group. Would you like to proceed?" |
*
* @param {Automatic_Sync_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_sync_confirm = /** @type {((inputs?: Automatic_Sync_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Sync_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_sync_confirm(inputs)
	if (locale === "de") return de_automatic_sync_confirm(inputs)
	if (locale === "it") return it_automatic_sync_confirm(inputs)
	if (locale === "ru") return ru_automatic_sync_confirm(inputs)
	if (locale === "es") return es_automatic_sync_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_sync_confirm(inputs)
	if (locale === "ja") return ja_automatic_sync_confirm(inputs)
	if (locale === "hi") return hi_automatic_sync_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_sync_confirm(inputs)
	return en_automatic_sync_confirm(inputs)
});